export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.30-1054.01",
  commitId: "eaa761d2bed83997743e5b7785f6fa7ab82a0f57",
  commitTime: "2026-06-30T10:54:01.000Z",
});
